import loader from './features/slices/loader/loader.slice'
import user from './features/slices/user'
const rootReducer = {
  loader,
  user
}
export default rootReducer
